<template>
  <div>

    <el-row>
      <h1>今日状态</h1>

      <el-row :gutter="20">
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <div class="sub-title">总告警</div>
            <div class="number hand">{{ allCount }}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <div class="sub-title">错误告警</div>
            <div class="number hand">{{ errorCount }}</div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <div class="sub-title">致命告警</div>
            <div class="number hand">{{ fatalCount }}</div>
          </div>
        </el-col>
      </el-row>
    </el-row>

    <div id="app1">
      <v-chart class="my-chart" :options="option1" style="width: 100%"/>
    </div>
    <div style="margin: 40px 0;"></div>

    <div id="app2">
      <v-chart class="my-chart" :options="option2" style="width: 100%"/>
    </div>
    <div style="margin: 40px 0;"></div>

    <div id="app3">
      <h1>最近100条告警信息</h1>

      <el-table
          :row-key="getRowKeys"
          :expand-row-keys="expands"
          @row-click="clickRowHandle"
          stripe

          v-show="resultVisible"
          :data="table"
          style="width: 100%">
        <!--            <el-table-column-->
        <!--                    prop="messageID"-->
        <!--                    label="消息ID"-->
        <!--                    width="80">-->
        <!--            </el-table-column>-->


        <el-table-column type="expand"
                         style="width: 5%">
          <template slot-scope="scope">
            <div style="padding-left: 60px;">

              <tr>
                <td class="css-1d24gbv-logs-row-details__label">环境</td>
                <td class="css-hh1wya-wordBreakAll">{{ scope.row.env || "null" }}</td>
              </tr>

              <tr>
                <td class="css-1d24gbv-logs-row-details__label">主机</td>
                <td class="css-hh1wya-wordBreakAll">{{ scope.row.host || "null" }}</td>
              </tr>

              <tr>
                <td class="css-1d24gbv-logs-row-details__label">项目名称</td>
                <td class="css-hh1wya-wordBreakAll">{{ scope.row.projectName || "null" }}</td>
              </tr>

              <tr>
                <td class="css-1d24gbv-logs-row-details__label">服务名称</td>
                <td class="css-hh1wya-wordBreakAll">{{ scope.row.serviceName || "null" }}</td>
              </tr>

              <tr>
                <td class="css-1d24gbv-logs-row-details__label">警报名称</td>
                <td class="css-hh1wya-wordBreakAll">{{ scope.row.alertName || "null" }}</td>
              </tr>


              <tr>
                <td class="css-1d24gbv-logs-row-details__label">重置规则信息</td>
                <td class="css-hh1wya-wordBreakAll">{{ scope.row.alertRuleInfo || "null" }}</td>
              </tr>

              <tr>
                <td class="css-1d24gbv-logs-row-details__label">消息标题</td>
                <td class="css-hh1wya-wordBreakAll">{{ scope.row.title || "null" }}</td>
              </tr>

              <tr>
                <td class="css-1d24gbv-logs-row-details__label">消息正文</td>
                <td class="css-hh1wya-wordBreakAll">{{ scope.row.message || "null" }}</td>
              </tr>


            </div>
          </template>
        </el-table-column>

        <el-table-column
            style="width: 5%"
            prop="level"
            label="消息等级">
          <template slot-scope="scope">
            <el-tag
                :type="(scope.row.level===levelMap[1].label ? 'info' : (scope.row.level===levelMap[2].label ? '' : (scope.row.level===levelMap[3].label ? 'warning' : (scope.row.level===levelMap[4].label ? 'danger': 'danger'))))"
                class="keyWordTag">
              {{ scope.row.level }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
            prop="createTime"
            label="消息时间"
            style="width: 10%">
        </el-table-column>

        <el-table-column
            :show-overflow-tooltip="true"
            prop="title"
            label="消息标题"
            style="width: 30%">
        </el-table-column>
        <el-table-column
            :show-overflow-tooltip="true"
            prop="message"
            label="消息正文"
            style="width: 30%">
        </el-table-column>

        <el-table-column
            prop="status"
            label="消息状态"
            style="width: 10%">

          <template slot-scope="scope">
            <el-tag
                :type="(scope.row.status===statusMap[1] ? 'info' :(scope.row.status===statusMap[2] ? 'success' : (scope.row.status===statusMap[3] ? 'danger':'danger')))"
                class="keyWordTag">
              {{ scope.row.status }}
            </el-tag>
          </template>

        </el-table-column>
        <el-table-column
            prop="type"
            label="消息类型"
            style="width: 10%">
          <template slot-scope="scope">
            <el-tag
                :type="(scope.row.type===typeMap[1] ? '' : (scope.row.type===typeMap[2] ? 'danger': 'danger'))"
                class="keyWordTag">
              {{ scope.row.type }}
            </el-tag>
          </template>

        </el-table-column>

      </el-table>

      <div style="text-align: center;margin-top: 30px;" v-show="resultVisible">
        <el-pagination
            background
            layout="prev, pager, next"
            @current-change="currentChange"
            :total="pageTotal">
        </el-pagination>
      </div>

    </div>
  </div>


</template>

<script>

import {Apis} from "@/api";

import ECharts from "vue-echarts/components/ECharts";
import "echarts/lib/chart/bar"
import {Utils} from "@/utils/utils";

export default {
  name: "App",
  components: {
    "v-chart": ECharts
  },

  data() {
    return {
      allCount: 0,
      errorCount: 0,
      fatalCount: 0,

      option1: {
        title: {
          text: '今日告警走势'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: []
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: 'value'
        },
        series: []
      },

      option2: {
        title: {
          text: '七日告警走势'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: []
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: 'value'
        },
        series: []
      },

      // 获取row的key值
      getRowKeys(row) {
        return row.messageID;
      },
      // 要展开的行，数值的元素是row的key值
      expands: [],

      resultVisible: false,

      pageSize: 10,
      pageTotal: 0,

      statusMap: {'1': "已记录", "2": "已通知", "3": "通知失败"},
      typeMap: {'1': "正常触发", '2': "规则触发"},

      levelMap: [{
        value: -1,
        label: '所有等级'
      },
        {
          value: 1,
          label: '信息'
        }, {
          value: 2,
          label: '警告'
        }, {
          value: 3,
          label: '错误'
        }, {
          value: 4,
          label: '致命'
        }],

      projectValue: "",

      serviceValue: "",

      alertValue: "",

      dateValue: [],
      levelValue: "",
      key: "",

      tableData: [],
      table: [],
    }

  },

  methods: {
    clickRowHandle(row, column, event) {
      console.log(row)
      if (this.expands.includes(row.messageID)) {
        this.expands = this.expands.filter(val => val !== row.messageID);
      } else {
        this.expands.push(row.messageID);
      }
    },

    dateFormatLong(timestamp, c) {
      const time = new Date(timestamp);    //先将时间戳转为Date对象，然后才能使用Date的方法
      const year = time.getFullYear(),
          month = time.getMonth() + 1,
          day = time.getDate(),
          hour = time.getHours(),
          minute = time.getMinutes(),
          second = time.getSeconds();
      return year + '-' + this.add0(month) + '-' + this.add0(day) + c + this.add0(hour) + ':' + this.add0(minute) + ':' + this.add0(second)
    },

    //根据页面下表获取列表数据
    currentChange(pageIndex) {
      // console.log("pageIndex:", pageIndex)
      this.table = this.tableData.slice((pageIndex - 1) * this.pageSize, (pageIndex) * this.pageSize)
      this.resultVisible = true
    },

    async getRecentData() {
      // console.log("我是个弹出框")

      const re = await Apis.Message.MessageSearchForRecent(100)
      this.tableData = re.data || []

      console.log("tableData 长度:", this.tableData.length)
      this.pageTotal = this.tableData.length
      this.currentChange(1)
      // if(this.tableData.length%this.pageSize!==0){
      //   this.pageTotal+=1
      // }
      this.resultVisible = true
      //
      // console.log("总数据条数:", this.tableData.length)
      // console.log(this.tableData.length/this.pageSize)
      // console.log(this.pageTotal)

    },

    async freshData(){
      await this.messageCount()
      await this.searchForToday()
      await this.searchForWeek()
      await this.getRecentData()
    },

    async timeOperation(count) {
      window.setInterval(this.freshData, count * 1000);
    },
    //
    add0(m) {
      return m < 10 ? '0' + m : m
    },
    //
    dateFormat(timestamp) {
      const time = new Date(timestamp);    //先将时间戳转为Date对象，然后才能使用Date的方法
      const year = time.getFullYear(),
          month = time.getMonth() + 1,
          day = time.getDate();
      return year + '-' + this.add0(month) + '-' + this.add0(day) + ' '
    },
    async searchForToday() {

      const today = this.dateFormat(new Date())

      const startDate = today + "00:00:00"
      const endDate = today + "23:59:59"

      // console.log(startDate, endDate)

      const response = await Apis.Message.MessageSearchForGraph(-1, -1, startDate, endDate, -1, -1, "")

      this.option1.xAxis.data = response.data.dateList ?? []
      this.option1.legend.data = response.data.keyList ?? []
      this.option1.series = response.data.series ?? []

    },
    async searchForWeek() {

      const end = new Date()
      const start = new Date();

      const today = this.dateFormat(end)
      const endDate = today + "23:59:59"

      const hour = start.getHours()
      const minute = start.getMinutes()
      const second = start.getSeconds()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7 - hour * 3600 * 1000 - minute * 60 * 1000 - second * 1000);
      const startDate = this.dateFormat(start) + "00:00:00"

      // console.log(startDate, endDate)
      const response = await Apis.Message.MessageSearchForGraph(-1, -1, startDate, endDate, -1, -1, "")

      this.option2.xAxis.data = response.data.dateList ?? []
      this.option2.legend.data = response.data.keyList ?? []
      this.option2.series = response.data.series ?? []

    },
    async messageCount() {

      const today = this.dateFormat(new Date())

      const startDate = today + "00:00:00"
      const endDate = today + "23:59:59"
      const response = await Apis.Message.MessageCount(startDate, endDate)

      this.allCount = response.data.allCount ?? -1
      this.errorCount = response.data.errorCount ?? -1
      this.fatalCount = response.data.fatalCount ?? -1
    },

    async initTeamOptions() {
      this.isLogin = Utils.isLogin()

      if (this.isLogin === true) {
        const response = await Apis.Team.listTeam()
        this.TeamOptions = response.data || []

        if (this.$cookies.get("currentTeamID") === null) {
          if (this.TeamOptions.length !== 0) {
            this.selectTeamID = this.TeamOptions[0]["value"]

          } else {
            this.selectTeamID = ""
            this.$message.error("请先选择一个部门加入")
          }
        } else {
          this.selectTeamID = parseInt(this.$cookies.get("currentTeamID"))
        }
        //移除原有cookie，加入新cookie
        this.$cookies.remove("currentTeamID");
        this.$cookies.set("currentTeamID", this.selectTeamID, 60 * 60 * 12); // 12 hour after, expire


      }

    },
  },
  created: async function () {
    //初始化cookie值
    await this.initTeamOptions()

    await this.messageCount()
    await this.searchForToday()
    await this.searchForWeek()


    await this.getRecentData()
    await this.timeOperation(30)
    // this.currentChange(1)
  },
}

</script>


<style lang="scss" scoped>
.sub-title {
  text-align: center;
  font-size: 20px;
  padding: 5px;
  background-color: #F2F6FC;
  color: #303133;
}

.number {
  font-size: 40px;
  text-align: center;
  color: #0078f8;
}

.el-row {
  margin-bottom: 20px;
}

.last-child {
  margin-bottom: 0;
}


.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #E4E7ED;
}

.bg-purple {
  background: #ffffff;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

h1 {
  text-align: center;
}


.login-btn {
  text-align: center;
}

.my-chart {
  width: 1500px;
  height: 500px;
}


</style>


<style scoped>
.my-chart {
  width: 1500px;
  height: 500px;
}

el-row {
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap
}

.el-card {
  min-width: 100%;
  height: 100%;
  margin-right: 20px;
  transition: all .5s;
}

.css-1d24gbv-logs-row-details__label {
  max-width: 30em;
  min-width: 20em;
  padding: 0px 8px;
  overflow-wrap: break-word;
}

.css-hh1wya-wordBreakAll {
  word-break: break-all;
}

</style>